import React, { Fragment, useEffect, useState, useCallback } from 'react';

import { api } from '../api';
import { ListGroup, Button, Form } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { VendorLocation, VendorLink } from './ItemReview';


function VendorList(props) {
    if(!props.vendors) {
        return <Fragment></Fragment>;
    }
    const listItems = props.vendors.map((vendor) =>
        <ListGroup.Item key={vendor.id} style={{border: "none"}}>
            <div style={{ padding: "24px 12px 24px 12px" }}>
                <h1><VendorLink vendor={vendor} /></h1>
                <div className="headerTextLight">{vendor.description}</div>
                <VendorLocation vendor={vendor}/>
            </div>
        </ListGroup.Item>
    );
    return (
        <div>
            <ListGroup>{listItems}</ListGroup>
        </div>
    );
}

function CheckBox(props) {
    return <Form.Check checked={props.territoryName===props.selectedName} type="radio" name="formRadios" id={props.territoryName} label={props.label} onChange={props.handleToggle} data-territoryname={props.territoryName}/>;
}

function VendorFilter(props) {
    const [selectedTerritory, setSelectedTerritory] = useState("");

    const handleToggle = useCallback((e) => {
        props.handleFilterChange(e.target.dataset.territoryname);
        setSelectedTerritory(e.target.dataset.territoryname);
    }, [props.handleFilterChange]);
    const handleClearFilter = useCallback(() => {
        props.handleFilterChange("");
        setSelectedTerritory("");
    }, []);
    return (
        <div class="lightOpaqueBackground" style={{padding: "24px", marginBottom: "24px"}}>
            <div class="bg-nav headerTextLight" style={{borderBottom: "1px solid #456"}}>Filter</div>
            <Form>
                <Form.Group controlId="formBasicCheckbox">
                    <CheckBox label={"All"} handleToggle={handleToggle} selectedName={selectedTerritory} territoryName={""}/>
                    <CheckBox label={"California"} handleToggle={handleToggle} selectedName={selectedTerritory} territoryName={"California"}/>
                    <CheckBox label={"Oregon"} handleToggle={handleToggle} selectedName={selectedTerritory} territoryName={"Oregon"}/>
                    <CheckBox label={"Washington"} handleToggle={handleToggle} selectedName={selectedTerritory} territoryName={"Washington"}/>
                </Form.Group>
                <Button onClick={handleClearFilter}>Clear Filter</Button>
            </Form>
        </div>);
}

function ShopsLoader(props) {
    const [vendors, setVendors] = useState(null);
    const [nextCursor, setNextCursor] = useState(null);
    const [territoryFilter, setTerritoryFilter] = useState(null);

    useEffect(() => {
        const params = { limit: territoryFilter ? 10 : 20 };
        if (territoryFilter) params.territory = territoryFilter;
        if (props.token) params.cursor = props.token;
        api.listVendors(params)
            .then((page) => {
                setVendors(page.items);
                setNextCursor(page.nextCursor);
            })
            .catch(() => {
                setVendors([]);
                setNextCursor(null);
            });
    }, [props.token, territoryFilter]);

    const handleFilterChange = useCallback((territoryName) => {
        setTerritoryFilter(territoryName);
    }, []);

    var nextLink = <Fragment />;
    var prevPath = (props.location) ? props.location.pathname : "";
    if(nextCursor) {
        nextLink = <NavLink to={{pathname: `/shops/${nextCursor}`, state: { prevPath: prevPath }}} >More</NavLink>;
    }
    var backLink = <Fragment />;
    if(props.token && props.location && vendors) {
        backLink = <NavLink to={props.location.state.prevPath}>Back</NavLink>;
    }
    return (
        <div style={{marginTop: "100px", marginLeft: "48px", marginRight: "48px", display: "inline-block"}}>
            <div style={{display: "inline-block", marginRight: "24px"}}>
                <VendorFilter handleFilterChange={handleFilterChange}></VendorFilter>
            </div>
            <div style={{display: "inline-block", verticalAlign: "top"}}>
                <VendorList vendors={vendors}></VendorList>
            </div>
            <div style={{display: "flex", fontSize: "20px"}}>
                <div style={{flexGrow: "1"}}>{backLink}</div>
                <div style={{flexGrow: "0"}}>{nextLink}</div>
            </div>
        </div>
    );
}


export { ShopsLoader };
